// Generate a random 16-digit card number (no Luhn check)

import { CardType } from "../BackEnd/Masters/DigitalCard/DigitalCard";

const formatDate = (dateString: string) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};

// Generate a card number with prefix + 13 digits
const generateValidCardNumber = (cardType: CardType) => {
    let prefix = '';

    switch (cardType) {
        case 'Gold':
            prefix = 'MGC';
            break;
        case 'Silver':
            prefix = 'MSC';
            break;
        case 'Green':
        default:
            prefix = 'MCC';
            break;
    }

    // generate 13 random digits
    let digits = '';
    for (let i = 0; i < 13; i++) {
        digits += Math.floor(Math.random() * 10);
    }

    return prefix + digits; // 3 letters + 13 digits = 16 chars
};


// Validate card number: only checks for 16-digit numeric string
const validateCardNumber = (cardNumber: string) => {
    const clean = cardNumber.replace(/\s+/g, '');
    // must match exactly: 3 uppercase letters + 13 digits
    return /^[A-Z]{3}[0-9]{13}$/.test(clean);
};


// Format card number with spaces for readability (e.g., 1234 5678 9012 3456)
const formatCardNumber = (value: string) => {
    const clean = value.replace(/[^A-Za-z0-9]/g, '').slice(0, 16);
    return clean.replace(/(.{4})/g, '$1 ').trim();
};

const getStatusColor = (status: string) => {
    switch (status) {
        case 'redeemed': return 'info';
        case 'claimed': return 'success';
        case 'expired': return 'error';
        case 'won': return 'error';
        default: return 'default';
    }
};

export { validateCardNumber, formatDate, formatCardNumber, generateValidCardNumber, getStatusColor }